import { ModelBase } from "@shoothill/core";
import { observable, action } from "mobx";

export class GenericFreeTextListItemModel extends ModelBase<GenericFreeTextListItemModel> {
    @observable
    public id: string | null = null;
    @observable
    public name: string = "";
    @observable
    public isDeleted: boolean = false;
    @observable
    public createdByUserId: string | null = "";
    @observable
    public createdDate: string | null = "";
    constructor() {
        super();
    }

    @action
    public handleDelete = (val: boolean) => {
        this.isDeleted = val;
    };

    fromDto(model: GenericFreeTextListItemDTO): void {
        this.id = model.id;
        this.name = model.name;
        this.isDeleted = model.isDeleted;
        this.createdByUserId = model.createdByUserId;
        this.createdDate = model.createdDate;
    }

    public static fromDtos(dtos: GenericFreeTextListItemDTO[]): GenericFreeTextListItemModel[] {
        const types: GenericFreeTextListItemModel[] = [];

        for (const dto of dtos) {
            const model = new GenericFreeTextListItemModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    toDto(): GenericFreeTextListItemDTO {
        return {
            id: this.id,
            name: this.name,
            isDeleted: this.isDeleted,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
        };
    }
}

export interface GenericFreeTextListItemDTO {
    id: string | null;
    name: string;
    isDeleted: boolean;
    createdByUserId: string | null;
    createdDate: string | null;
}
